import { render } from "./PersonalitiesSettings.vue?vue&type=template&id=18ebeba4"
import script from "./PersonalitiesSettings.vue?vue&type=script&lang=js"
export * from "./PersonalitiesSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__